import { findIconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import type { IconLookup, IconName } from '@awesome.me/kit-ff9dd7b804/icons/modules';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

declare module '@fortawesome/fontawesome-svg-core' {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  export function icon(icon: IconName | IconLookup, params?: IconParams): Icon;

  // eslint-disable-next-line @typescript-eslint/no-shadow
  export function findIconDefinition(iconLookup: IconLookup): IconDefinition;
}

export function mcmEndpointToIcon(edp: string, visible: boolean): IconProp {
  switch (edp.split('-')[0].toLowerCase()) {
    case 'laptop':
      return visible
        ? 'laptop-mobile'
        : findIconDefinition({ prefix: 'fak', iconName: 'solid-laptop-mobile-slash' });
    case 'mobile':
      return visible
        ? 'mobile'
        : findIconDefinition({ prefix: 'fak', iconName: 'solid-mobile-slash' });
    case 'tv':
      return visible ? 'tv' : findIconDefinition({ prefix: 'fak', iconName: 'solid-tv-slash' });
    case 'plug':
      return visible ? 'plug' : findIconDefinition({ prefix: 'fak', iconName: 'solid-plug-slash' });
    case 'sign':
      return visible
        ? 'sign-posts'
        : findIconDefinition({ prefix: 'fak', iconName: 'solid-sign-posts-slash' });
    case 'calendar':
      return visible
        ? 'calendar-days'
        : findIconDefinition({ prefix: 'fak', iconName: 'solid-calendar-days-slash' });
    case 'newspaper':
      return visible
        ? ['fass', 'newspaper']
        : findIconDefinition({ prefix: 'fak', iconName: 'sharp-solid-newspaper-slash' });
    case 'server':
      return visible
        ? 'server'
        : findIconDefinition({ prefix: 'fak', iconName: 'solid-server-slash' });
    default:
      return 'question';
  }
}
